var _excluded = ["selectedDate", "activeMonth"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { addMonths } from 'date-fns';
import { flatten } from 'lodash';
import { createActiveMonth } from './createActiveMonth';
import { getPartialWeeks } from './getPartialWeeks';
export var getNextAvailableDay = _ref => {
  var {
    selectedDate,
    activeMonth
  } = _ref,
      partialWeeksProps = _objectWithoutProperties(_ref, _excluded);

  var weeks = getPartialWeeks(_objectSpread({
    selectedDate,
    activeMonth
  }, partialWeeksProps));
  var days = flatten(weeks);
  var availableDay = days.find(day => day ? !(day !== null && day !== void 0 && day.isDisabled) : undefined);
  return availableDay !== null && availableDay !== void 0 ? availableDay : getNextAvailableDay(_objectSpread(_objectSpread({
    selectedDate
  }, partialWeeksProps), {}, {
    activeMonth: createActiveMonth(addMonths(activeMonth.date, 1))
  }));
};
//# sourceMappingURL=getNextAvailableDay.js.map